<template>
  <div>
    <b-table
      :items="documentos"
      :fields="fields"
      small
      responsive
    >
      <template #cell(nome)="{ item }">
        <span>{{ item.documento.descrição }}</span>
        <span
          v-if="item.status"
          :class="['ml-2', getStatusClass(item.status)]"
          :title="getStatusLabel(item.status)"
        >
          <small>{{ getStatusLabel(item.status) }} {{ item.status === 4 ? ` - ${item.recusadoJust}` : '' }}</small>
        </span>
      </template>
      <template #cell(acoes)="{ item }">
        <b-btn
          size="sm"
          variant="primary"
          class="mr-1"
          :disabled="!podeReenviar(item)"
          @click="abrirUpload(item)"
        >
          <span v-if="item.nomeArq && item.status === 4">Reenviar</span>
          <span v-else-if="!item.nomeArq">Upload</span>
          <span v-else>Upload</span>
        </b-btn>
      </template>
    </b-table>
    <b-modal
      v-model="showUploadModal"
      title="Enviar Documento"
      @hide="uploadFile=null"
    >
      <div v-if="uploadFile">
        <b-form-file
          v-model="selectedFile"
          :state="Boolean(selectedFile)"
          placeholder="Escolha um arquivo..."
          drop-placeholder="Solte o arquivo aqui..."
        />
      </div>
      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="showUploadModal=false"
        >Cancelar</b-button>
        <b-button
          variant="primary"
          :disabled="!selectedFile"
          @click="enviarArquivo"
        >Enviar</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '@/app-modulo/comercial/portal-proposta/shared/services/api'
import { enviarNuvem } from '@/shared/mixins/upload-wasabi/upload-wasabi'

export default {
  name: 'DocumentosPropostaSection',
  props: {
    propostaId: {
      type: [Number, null],
      default: null,
      required: false,
    },
  },
  data() {
    return {
      documentos: [],
      fields: [
        { key: 'nome', label: 'Documento' },
        { key: 'acoes', label: 'Ações', class: 'text-right' },
      ],
      showUploadModal: false,
      uploadFile: null,
      selectedFile: null,
    }
  },
  watch: {
    propostaId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.fetchDocumentos()
      }
      if (!newVal) {
        this.documentos = []
      }
    },
  },
  created() {
    if (this.propostaId) {
      this.fetchDocumentos()
    }
  },
  methods: {
    getStatusLabel(status) {
      const map = {
        0: 'Nenhum',
        1: 'Aguardando homologação',
        2: 'Pendente',
        3: 'Homologado',
        4: 'Recusado',
        5: 'Cancelado',
        6: 'Dispensado',
      }
      return map[status] || 'Desconhecido'
    },
    getStatusClass(status) {
      // Cores visuais para cada status
      switch (status) {
        case 1: return 'text-warning' // Aguardando homologação
        case 2: return 'text-secondary' // Pendente
        case 3: return 'text-success' // Homologado
        case 4: return 'text-danger' // Recusado
        case 5: return 'text-muted' // Cancelado
        case 6: return 'text-info' // Dispensado
        default: return 'text-body'
      }
    },
    fetchDocumentos() {
      api.getPropostaDocumentos(this.propostaId)
        .then(response => {
          this.documentos = (response.data || []).map(doc => ({ ...doc, naoSeAplica: false }))
        })
        .catch(() => {
          this.documentos = []
        })
    },
    podeReenviar(item) {
      // Só permite upload se não houver arquivo ainda, ou se status for Recusado (4)
      if (!item.nomeArq) return true
      return item.status === 4
    },
    habilitaUpload(item) {
      return item && !item.nomeArq
    },
    abrirUpload(item) {
      this.uploadFile = item
      this.selectedFile = null
      this.showUploadModal = true
    },
    enviarArquivo() {
      if (!this.selectedFile || !this.uploadFile) return
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      this.$isLoading(true)
      // O id correto é o do documento (this.uploadFile.id)
      api.getDadosUpload(this.uploadFile.id, formData)
        .then(response => {
          enviarNuvem(response.data.arquivoNovo, this.selectedFile, response.data.storage)
            .then(promise => {
              if (promise && promise.sucesso) {
                // Para alterar-status, envie o arquivo como 'file' em FormData e observacao na query
                const statusForm = new FormData()
                statusForm.append('file', this.selectedFile)
                api.atualizaDocumentoStatusAguardando(
                  this.uploadFile.id,
                  statusForm,
                  { observacao: response.data.observacao },
                )
                  .then(() => {
                    this.notificarSucesso('Documento enviado com sucesso!')
                    this.showUploadModal = false
                    this.$isLoading(false)
                    this.uploadFile = null
                    this.selectedFile = null
                    this.fetchDocumentos()
                  })
                  .catch(err => {
                    api.limparEnvioDocumentoNuvem(this.uploadFile.id, this.selectedFile)
                      .then(() => {
                        this.$isLoading(false)
                      })
                    const resolved = this.$resolveError(err)
                    const message = resolved.detail || resolved.title || err.message
                    this.notificarErro(message, this.uploadFile)
                  })
              }
            })
        })
        .catch(() => {
          this.notificarErro('Erro ao enviar documento.')
        })
    },
    notificarErro(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    },
    notificarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'SuccessCircleIcon',
          variant: 'success',
        },
      })
    },
  },
}
</script>
